import { gql } from "@apollo/client"

export const GET_LICENSED_INFORMATION = gql`
  query getLicensedInformation($data: GetLicensedInformationInput!) {
    licensePools {
      getLicensedInformation(data: $data) {
        programs {
          id
          name
          gradeLevelNames
          courses {
            id
            name
            gradeLevelNames
          }
          licenses {
            id
            entityTypes
            content
            endDate
            product
            startDate
            navName
            navCategory
          }
        }
      }
    }
  }
`
